import { render, staticRenderFns } from "./GenericBCDView.vue?vue&type=template&id=0d72a548&scoped=true"
import script from "./GenericBCDView.vue?vue&type=script&lang=js"
export * from "./GenericBCDView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d72a548",
  null
  
)

export default component.exports